import FilterSidePanel from "./FilterSidePanel";
import "./FilterSidePanel.scss";

export default FilterSidePanel;